import { Form } from "antd/es";
import { PureComponent, ReactNode } from "react";
import KuikaSwitch from "../../../../ui-kit/kuika-switch/kuika-switch";
import { ConfigField } from "../config-pane-parts";

export interface IConfigIsHapticEnabledProps {
  parentData: string;
}

export class ConfigIsHapticEnabled extends PureComponent<IConfigIsHapticEnabledProps> {
  formInputName: string[] = ["", "isHapticEnabled"];

  constructor(props: IConfigIsHapticEnabledProps) {
    super(props);
    this.formInputName[0] = props.parentData;
  }

  render(): ReactNode {
    const contentKey: string =
      this.props.parentData === "androidConfig" ? "android_mobileappsettings_haptic" : "ios_mobileappsettings_haptic";
    return (
      <ConfigField label="Haptic Enabled" tooltipContentKey={contentKey}>
        <Form.Item name={this.formInputName} valuePropName="checked" noStyle>
          <KuikaSwitch />
        </Form.Item>
      </ConfigField>
    );
  }
}
